import { OrganizationMembersCard } from "@daveyplate/better-auth-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization/members")({
  component: RouteComponent,
});

function RouteComponent() {
  return <OrganizationMembersCard />;
}
